import React, { useEffect, useState, useRef, useCallback} from 'react' 
import  $ from 'jquery'
import { Link, Route, Routes, useSearchParams  } from 'react-router-dom'
import '../layout/Products.Module.css'
import { prods, cate } from '../prods'
import { ourBrands, reBrands } from '../brands'
import bgImg from '../images/ex1.png'
import Slider from "react-slick";
import { useTranslation } from 'react-i18next';
import slugify from 'slugify'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrows, faHeart, faL } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from './AuthContext';
import {colors, getTranslatedColorName } from '../colors';
import {addToRecentView } from './ProdDetail';
import { useLanguage } from './LanguageContext';
import ProductCard from './ProductCard'
import useGoogleTranslateRefresh from './hooks/useGoogleTranslateRefresh';
import useScrollReveal from './hooks/useScrollReveal';
import QuickViewModal from './hooks/QuickViewModal'

const customTranslations = {
  'campânula': {
    'es': 'Campana',
    'en': 'Campanula',
    'fr': 'Campanule',
    'it': 'Campanula',
    'zh-CN': '风铃草' // Código do idioma para Chinês Simplificado
  }
};
function Produtos() {
  useScrollReveal(true);
  const { selectedLanguage } = useLanguage();
  const { user, toggleFavorite } = useAuth()
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState([]);
  const { t, i18n } = useTranslation('');
  const [products, setProducts] = useState([]);
  const [currentTab, setCurrentTab] = useState('1');
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = Number(searchParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [language, setLanguage] = useState(i18n.language || 'pt'); // idioma padrão
  const [translatedProducts, setTranslatedProducts] = useState({});
  const [loading, setLoading] = useState(true);
  const [onlyNew, setOnlyNew] = useState(false);
  const itemPerPage = 24;

  useEffect(() => {
  const CACHE_KEY = 'produtos';
  const CACHE_TTL = 1000 * 60 * 10; // 10 minutos
  
  const raw = localStorage.getItem(CACHE_KEY);
  if (raw) {
    const { timestamp, data } = JSON.parse(raw);
    if (Date.now() - timestamp < CACHE_TTL) {
      setProducts(data);
      setLoading(false);
      return;
    }
  }
    const fetchProducts = async () => {
      try {
        const response = await fetch('https://backend-theta-gold-17.vercel.app/produtos');
        const data = await response.json();
        if (Array.isArray(data)) {
          setProducts(data);
          localStorage.setItem(CACHE_KEY, JSON.stringify({ timestamp: Date.now(), data }));
          setLoading(false);
        } else {
          console.error('A API não retornou um array.');
        }
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      }
    };
    fetchProducts();
  }, []);

  const predefinedIps = [
    { ip: '20' },
    { ip: '33' },
    { ip: '40' },
    { ip: '42' },
    { ip: '44' },
    { ip: '54' },
    { ip: '55' },
    { ip: '65' },
    { ip: '66' },
    { ip: '67' },
    { ip: '68' },
    { ip: '69K'},
    // Adicione mais IPs conforme necessário
  ];
const [listIps, setListIps] = useState(predefinedIps);
const predefinedIks = [
  { ik: '04' },
  { ik: '06' },
  { ik: '07' },
  { ik: '08' },
  { ik: '10' },
  // Adicione mais IPs conforme necessário
];

/**************MYSQL database****************** */
const [categorias, setCategorias] = useState([])
useEffect(() => {
  const CACHE_KEY = `categorias-${i18n.language}`;
  const CACHE_TTL = 1000 * 60 * 10; // 10 minutos

  const raw = localStorage.getItem(CACHE_KEY);
  if (raw) {
    const { timestamp, data } = JSON.parse(raw);
    if (Date.now() - timestamp < CACHE_TTL) {
      setCategorias(data);
      return;
    }
  }

  const fetchAndTranslateCategories = async () => {
    try {
      const response = await fetch('https://advancelighting.pt/listaCategorias.php');
      const data = await response.json();
      const translated = data.map(c => ({
        ...c,
        nome: i18n.language === 'pt' 
          ? c.nome 
          : t(`categorias.${c.nome}`),
      }));
      setCategorias(translated);
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ timestamp: Date.now(), data: translated })
      );
    } catch (err) {
      console.error('Erro ao buscar e traduzir categorias:', err);
    }
  };

  fetchAndTranslateCategories();
}, [i18n.language]);

  var settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll:2,
          infinite: true,
          dots: false
        }
      }
    ]
  };

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  /**************Get atributes of produt to use on filter*************/
  const handleCheckboxChange = (e) =>{
    const value = e.target.value;
    setSelectedOptions((prevSelected)=>{
      if(prevSelected.includes(value)){
        return prevSelected.filter((option)=> option !== value);
      
      } else{
        return [...prevSelected,value];
      }
    });
    setCurrentPage(1);
    const params = new URLSearchParams(searchParams);
    params.set('page', '1');
    setSearchParams(params);
  };

  function extractPowerValue(powerStr) {
    if (!powerStr || typeof powerStr !== 'string') return null;
  
    // Encontra todos os números, incluindo os decimais
    const matches = powerStr.match(/(\d+(\.\d+)?)/g);
    if (!matches || matches.length === 0) return null;
  
    // Transforma em números
    const numbers = matches.map(Number);
  
    // Retorna o maior valor encontrado
    return Math.max(...numbers);
  }

  const powerRanges = [
    { label: "0-5W", min: 0, max: 5 },
    { label: "6-10W", min: 6, max: 10 },
    { label: "11-20W", min: 11, max: 20 },
    { label: "21-50W", min: 21, max: 50 },
    { label: "51W+", min: 51, max: Infinity },
  ];

  const filteredData = products.filter((item) => {
    const belongsToCategory = selectedCategories.length === 0 || selectedCategories.some(id => item.id_Cat === id || (Array.isArray(id) && id.includes(item.id_Cat)));
    const selectedCategoriesNames = selectedOptions.filter(option => 
      categorias.some(cat => cat.nomeOriginal === option)
    );

    const selectedPowerRanges = selectedOptions.filter(option =>
      powerRanges.some(range => range.label === option)
    );
    
    const matchesPower =  selectedPowerRanges.length === 0 || (() => {
        const powerValue = extractPowerValue(item.w);
        if (powerValue == null) return false; // ignora produto se não tem potência e filtro está ativo
    
        return selectedPowerRanges.some(label => {
          const range = powerRanges.find(r => r.label === label);
          return range && powerValue >= range.min && powerValue <= range.max;
        });
      })();

    if (selectedOptions.length === 0) {
      return belongsToCategory;
    }

    const selectedColors = selectedOptions.filter(option => colors.some(color => color.cor === option));
    const selectedIps = selectedOptions.filter(option => predefinedIps.some(ip => ip.ip === option));
    const selectedIks = selectedOptions.filter(option => predefinedIks.some(ik => ik.ik === option));
    const selectedBrands = selectedOptions.filter(option => ourBrands.concat(reBrands).some(brand => brand.name === option));
    const matchesColor = selectedColors.length === 0 || selectedColors.includes(item.cor);
    const matchesIp = selectedIps.length === 0 || selectedIps.includes(String(item.ip));
    const matchesIk = selectedIks.length === 0 || selectedIks.includes(String(item.ik));
    const matchesCategory = selectedCategoriesNames.length === 0 || selectedCategoriesNames.includes(item.nomeC);
    const matchesBrand = selectedBrands.length === 0 || selectedBrands.includes(item.marca);
    const matchesNew = !selectedOptions.includes("Apenas Novidades") || item.novo === 1;
    return belongsToCategory && matchesColor && matchesIp && matchesIk && matchesBrand && matchesCategory && matchesNew && matchesPower;
  });

  function handleSubcategoryClick(subcategory) {
    setSelectedOptions((prevSelectedOptions) => {
      // Verifica se a subcategoria já está selecionada
      if (prevSelectedOptions.includes(subcategory)) {
        // Se já estiver selecionada, removemos da lista (desmarcando)
        return prevSelectedOptions.filter(option => option !== subcategory);
      }
      // Caso contrário, adicionamos à lista de selecionados (marcando)
      return [...prevSelectedOptions, subcategory];
    });
  }

const [tabActive, setTabActive] = useState(0);
const categoryIcon = document.querySelectorAll('.main-filter-list li');
//Tab active icon function
$('.main-filter-list li').on('click', function(e){
  $(this).addClass('active');
})

const allIndicator = document.querySelectorAll('.main-filter-list li');

allIndicator.forEach(item=> {
  item.addEventListener('click', function () {

    allIndicator.forEach(i=> {i.classList.remove('active'); })
    $(this).addClass('active');
  })
})

const pages = []
for(let i=1; i <= Math.ceil(filteredData.length / itemPerPage); i++){
    pages.push(i);
}

const totalPages = pages.length;
const pagesToShow = 4;
const halfPagesToShow = Math.floor(pagesToShow / 2);
let startPage = Math.max(currentPage - halfPagesToShow, 1);
let endPage = Math.min(startPage + pagesToShow - 1, totalPages);
let lastIndexPage = currentPage * itemPerPage;
let firstItemPage = lastIndexPage - itemPerPage;
const listProds = filteredData.slice(firstItemPage,lastIndexPage)

if (endPage - startPage < pagesToShow - 1) {
  startPage = Math.max(endPage - pagesToShow + 1, 1);
}

const mpages = [];
for (let i = startPage; i <= endPage; i++) {
  mpages.push(i);
}

useEffect(() => {
  localStorage.setItem('currentPage', currentPage);
}, [currentPage]);

const onPageChange = (page) => {
  const params = new URLSearchParams(searchParams);
  params.set('page', page.toString());
  setSearchParams(params);

  setTimeout(() => {
    triggerGoogleTranslateRefresh(); // também força retradução ao mudar de página
  }, 300);
};

const triggerGoogleTranslateRefresh = () => {
  const combo = document.querySelector('.goog-te-combo');
  const savedLang = localStorage.getItem("language") || "pt";

  if (combo && combo.value !== savedLang) {
    combo.value = savedLang;
    combo.dispatchEvent(new Event("change"));
    console.log(`Reaplicando idioma: ${savedLang}`);
  } else {
    console.log(`Idioma já está correto (${savedLang}), não precisa reaplicar.`);
  }
};

const handleTabClick = (id) => {
  const isGrouped = Array.isArray(id);
  const idsToToggle = isGrouped ? id : [id];

  // Se já está ativo, desmarcar (limpar seleção)
  if (selectedCategories.length > 0 && selectedCategories.every(catId => idsToToggle.includes(catId))) {
    setSelectedCategories([]);
    setCurrentTab(null);
  } else {
    // Ativa apenas o grupo ou a categoria clicada
    setSelectedCategories(idsToToggle);
    setCurrentTab(id);
  }

  setCurrentPage(1);
  const params = new URLSearchParams(searchParams);
  params.set('page', '1');
  setSearchParams(params);
  
  setSelectedOptions([]);
  setSelectedSubCategories([]);
  setTimeout(() => {
    triggerGoogleTranslateRefresh(); // força retradução após atualização do DOM
  }, 300); // pequeno delay para garantir que o conteúdo foi renderizado
};
  const twoFunctions =(id)=>{
    addToRecentView(id);
  }

  useEffect(() => {
    const pageFromURL = Number(searchParams.get("page")) || 1;
    setCurrentPage(pageFromURL);
}, [searchParams.get("page")]);

    const [quickViewProduct, setQuickViewProduct] = useState(null);
    const [showQuickView, setShowQuickView] = useState(false);

    const handleQuickView = (idP) => {
      setQuickViewProduct(idP);
      setShowQuickView(true);
    };

    const closeQuickView = () => {
      setShowQuickView(false);
      setQuickViewProduct(null);
    };
  return (
    <div className='Produtos'>
      <div className="homepage-intro has-bg-img position-relative">
        <h2 className="text-center text-white position-absolute top-50 start-50 translate-middle scroll-top">{t('produtos.todosP')}</h2>
        <div className='background-dark'>
        </div>
      </div>

      <div className='filter-subcategory'>
        <div id='filter-bar'>
          <div className='container scroll-categories'>
      <ul id="main-filter-list" className="main-filter-list nav nav-tabs cats_list scroll-bottom" role="tablist">
      <Slider {...settings}>
      {categorias.map((tab,index)=>(
        <li className={`item-category notranslate ${selectedCategories.some(id => Array.isArray(tab.id) ? tab.id.includes(id) : id === tab.id) ? "active" : ""}`} key={index}id={tab.id} onClick={() => handleTabClick(tab.id)}>
          <a> <span>
            <img className="filter-bar-icons" src={tab.icone} alt={tab.nome}/>
            <span>{tab.nome}</span>
          </span>
          </a>
        </li>
        ))}
        </Slider>
        </ul>

      </div>
        </div>
        {/*
        <div className="padding-bottom-20 product_list">
         <div className="tab-content plist">
            <div role="tabpanel" className="tab-pane active">
              <div className="ins-filter-wrapper">
                <div className="container">
                  <div className="col-xs-12 padding-0">
                    <div className="padding-top-bottom-10 col-xs-12 col-md-12 col-lg-12 pfilters">
                    {categorias.map((tab, i) => (
                    <div key={tab.id} id={tab.id} className={currentTab === tab.id ? "active-content active" : "noactive-content"} onClick={() => handleTabClick(tab.id)}>
                    {selectedCategory === null || selectedCategory === tab.id ? (
                    tab.subcategorias?.map((cont, i) => (
                      
                    <span className="subCategoryItem" key={i}>
                    <input type="checkbox" className="css-checkbox" id={cont.nome} name={cont.nome}
                    value={cont.nome} checked={selectedOptions.includes(cont.nome)} // Garante que o estado da checkbox reflete o estado da aplicação
                    onChange={() => handleSubcategoryClick(cont.nome)} />
                    <label className="checkbox_label col-xs-6 col-sm-3 col-md-2" htmlFor={cont.nome}>
                    {cont.translated}
                    </label>
                    </span>
                    ))
                    ) : null}
                    </div>
                    ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        */}
      </div>

      <div className="container-xxl mx-auto m-5">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb"> 
            <li className="breadcrumb-item"><a className="text-decoration-none text-uppercase" href="/produtos">{t('homepage.produtos')}</a></li>
            <li className="breadcrumb-item active text-uppercase" aria-current="page"></li>
          </ol>
        </nav>

        <div className="d-flex justify-content-between align-items-md-center mb-3 py-2 py-lg-0 prod-list-top-btns">
          <div className="dropdown btn-open-filters">
            <button className="btn btn-secondary open-filters hide-filterbutton mr-auto fw-bold text-uppercase" data-bs-toggle="offcanvas" href="#prodFilters" role="button" aria-controls="prodFilters">{t('produtos.filtro')}</button>
          </div>

        </div>

        <div className="row">
          <div className="col-12 col-md-3 col-xl-2 prod-list-filter-wrapper offcanvas offcanvas-start" tabIndex={-1} id="prodFilters" aria-labelledby="prodFilters">
            <div className="offcanvas-header d-lg-none pe-0">
              <button className="btn ms-auto px-3" type="button" data-bs-dismiss="offcanvas" aria-label="Close"><i className="fa-solid fa-backward" /></button>
            </div>
            <div className="offcanvas-body p-3 pt-2 pb-3 scroll-right">

          <div className="filter-block">
          <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterMarcas" aria-expanded="false" aria-controls="filterMarcas">{t('navbar.marcas')}</button>
          <div className="prod-list-filter-list collapse show" id="filterMarcas">
              <div className="custom-scroll">
              {ourBrands.map((item,index)=>(
                  <label className="material-checkbox text-uppercase" key={index}>
                  <input type="checkbox" id={item.name} name={item.name} value={item.name} checked={selectedOptions.includes(item.name)} onChange={handleCheckboxChange}/>
                  <span className="checkmark"></span>
                  {item.name}
                  </label>
              ))} 

              {reBrands.map((item,index)=>(
                  <label className="material-checkbox text-uppercase" key={index}>
                  <input type="checkbox" id={item.name} name={item.name} value={item.name} checked={selectedOptions.includes(item.name)} onChange={handleCheckboxChange}/>
                  <span className="checkmark"></span>
                  {item.name}
                  </label>
              ))} 
              </div>
          </div>

          <hr className="card-line w-100" />
          <div className="filter-block">
            <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterNovo" aria-expanded="false" aria-controls="filterNovo">Novo</button>
              <div className="prod-list-filter-list collapse" id="filterNovo">
              <div className="custom-scroll">
              <label className="material-checkbox text-uppercase">
                <input type="checkbox" value="Apenas Novidades" checked={selectedOptions.includes("Apenas Novidades")} onChange={handleCheckboxChange} />
                <span className="checkmark"></span>
                {t('listProds.novo')}
              </label>
              </div>
              </div>
            </div>

          <hr className="card-line w-100" />
          <div className="filter-block">
            <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterW" aria-expanded="false" aria-controls="filterW">{t('pdetail.potencia')}(W)</button>
              <div className="prod-list-filter-list collapse" id="filterW">
              <div className="custom-scroll">
              {powerRanges.map((range, index) => (
                  <label className="material-checkbox" key={index}>
                    <input type="checkbox" value={range.label} checked={selectedOptions.includes(range.label)} onChange={handleCheckboxChange}    />
                    <span className="checkmark"></span> {range.label}
                  </label>
                ))}
              </div>
              </div>
            </div>

            <hr className="card-line w-100" />
            <div className="filter-block">
              <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterIp" aria-expanded="false" aria-controls="filterIp">IP</button>
              <div className="prod-list-filter-list collapse" id="filterIp">
                <div className="custom-scroll">
                {listIps.map((item,index)=>(
                  <label className="material-checkbox" key={index}>
                  <input type="checkbox" id={item.ip} value={item.ip.toString()} checked={selectedOptions.includes(item.ip.toString())} onChange={handleCheckboxChange}/>
                  <span className="checkmark"></span> {item.ip}
                </label> ))}
                </div>
              </div>
            </div>
              

            <hr className="card-line w-100" />
            <div className="filter-block">
                <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterIk" aria-expanded="false" aria-controls="filterIk">IK</button>
                <div className="prod-list-filter-list collapse" id="filterIk">
                  <div className="custom-scroll">
                  {predefinedIks.map((item,index)=>(
                    <label className="material-checkbox" key={index}>
                    <input type="checkbox" id={item.ik} value={item.ik.toString()} checked={selectedOptions.includes(item.ik.toString())} onChange={handleCheckboxChange}/>
                    <span className="checkmark"></span>
                    {item.ik}
                  </label>
                    ))}
                  </div>
                </div>
            </div>

              
            <hr className="card-line w-100" />
              <div className="filter-block">
                <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filtercor" aria-expanded="false" aria-controls="filtercor">{t('pdetail.cor')}</button>
              <div className="prod-list-filter-list collapse" id="filtercor">
                  <div className="custom-scroll colorList">
                {colors.map((item, index) => (
                  <label className="material-checkbox filter-field" key={index}>
                    <input type="checkbox" id={item.cor} value={item.cor} 
                      checked={selectedOptions.includes(item.cor)} 
                      onChange={handleCheckboxChange}  />
                    <span className="checkmark"></span>
                    {item.nome[selectedLanguage]}
                  </label>
                  ))}
                  </div>
              </div>
            </div>
              {/*<hr className="card-line w-100" />
              <div className="filter-block">
                <button className="filter-title collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterType" aria-expanded="false" aria-controls="filterType">{t('produtos.tipo')}</button>
                <div className="prod-list-filter-list collapse" id="filterType">
                  <div className="custom-scroll">
                  {categoriasOri.map((item)=>(
                    <label  className="material-checkbox text-capitalize" key={item.id}>               
                    <input type="checkbox" id={item.nome} value={item.nomeOriginal} checked={selectedOptions.includes(item.nomeOriginal)} onChange={handleCheckboxChange}/>
                     <span className='checkmark'></span>
                     {item.nome} 
                    </label>
                    ))}
                  </div>
                </div>
              </div>*/}

              </div>
            </div>
          </div>

          <div className="col-12 col-md prod-list-content-wrapper scroll-bottom">
            <div className="row g-4 prod-list-wrapper position-relative" id="prod-list">
            <span className='total-prods'>{t('listProds.existem')} <b>{filteredData.length}</b> {t('homepage.produtos')}</span>
              {listProds.map((resu,index)=>
              {
                return (
                  <div className="col-sm-6 col-lg-3 col-md-3 col-6 product-card" key={index}>
                    <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t}/>
                  </div>
                );
              })}
            </div>
          </div>
        {quickViewProduct && (
          <QuickViewModal productId={quickViewProduct} isOpen={showQuickView} onClose={closeQuickView} />
        )}
        <div className='center-pagination'>
            <section className="pagination-section p-5 bd-highlight mb-3">
            <ul className="pagination-prods">
            <li>
            <button id="pg-button-prev" type="button" className="pagination__button" onClick={()=>onPageChange(currentPage-1)} disabled={currentPage ===1}>
              <i className="fa fa-chevron-left" />
            </button>
            </li>
            {startPage > 1 &&(
              <>
              <button className='pagination__button_ellipses' onClick={()=>onPageChange(1)}>1</button>
              {startPage > 2 && <span className='pagination__button_ellipses'>...</span>}
              </>
            )}
              {
                mpages.map((page,index)=>{
                    return(
                    <li className={page ===  currentPage ? 'active' : ''} key={index}  onClick={()=>onPageChange(page)}>
                      <button id="pg-button-1" type="button">{page}</button>
                    </li>
                    )
                  })
              }
            {endPage <totalPages &&(
              <>
              {endPage < totalPages -1 && <button className="pagination__button_ellipses">...</button>}
              <button className="pagination__button_ellipses" type="button" onClick={()=> onPageChange(totalPages)}>
                {totalPages}
              </button>
              </>
            )}
            <li>

            <button id="pg-button-next" type="button" className="pagination__button" 
              onClick={()=>onPageChange(currentPage+1)} disabled={currentPage === Math.ceil(filteredData.length / itemPerPage)}>
              <i className="fa fa-chevron-right" />
            </button>
            </li>

            </ul>
          </section>
        </div>

        </div>
      </div>
  
    </div>
  )
}

export default Produtos